<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">Financial Summary</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <div class="pea-panel" v-if="panelOpen" v-loading="dataLoading">
        <el-form :model="financialSummaryData" :rules="rules" ref="financialSummaryForm" class="financialSummary">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>Capital Assets:</strong>
                </el-col>
                <el-col :sm="12" :md="12" :lg="4">
                  $ {{ formatMoney(capitalAssetsTotalAmount) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>Operating Leases:</strong>
                </el-col>
                <el-col :sm="12" :md="12" :lg="4">
                  $ {{ formatMoney(operatingLeasesTotalAmount) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>Other Expenditures:</strong>
                </el-col>
                <el-col :sm="12" :md="12" :lg="4">
                  $ {{ formatMoney(otherExpendituresTotalAmount) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>Total Expenditures:</strong>
                </el-col>
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>$ {{ formatMoney(expendituresTotalAmount) }}</strong>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="canEditCostToDate || showCostToDate">
                <el-col :sm="12" :md="12" :lg="4">
                  <strong>Cost to Date:</strong>
                </el-col>
                <el-col :sm="12" :md="12" :lg="4">
                  <el-form-item prop="costToDate">
                    <currency-input :disabled="!canEditCostToDate" :clearable="canEditCostToDate" v-model="financialSummaryData.costToDate"></currency-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </transition>
  </el-row>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-financial-summary',
  props: {
    peaId: {
      default: 0
    },
    disabled: {
      default: false
    },
    canEditCostToDate: {
      default: false
    },
    isCompleting: {
      default: false
    }
  },
  computed: {
    showCostToDate: function () {
      // if completed or approved then show
      if (this.$parent.$refs.peaSummary.peaCore.peaStatusId === 4 || this.$parent.$refs.peaSummary.peaCore.peaStatusId === 7) {
        return true
      } else {
        return false
      }
    },
    capitalAssetsTotalAmount: function () {
      // related to prd.pub fix in peaFinancialAssets.vue
      if (parseFloat(this.$parent.$refs.peaFinancialAssets.capitalAssetsTotalAmount) === this.$parent.$refs.peaFinancialAssets.capitalAssetsTotalAmount) {
        return this.$parent.$refs.peaFinancialAssets.capitalAssetsTotalAmount.toFixed(2)
      }
    },
    operatingLeasesTotalAmount: function () {
      // related to prd.pub fix in peaFinancialAssets.vue
      if (parseFloat(this.$parent.$refs.peaFinancialAssets.operatingLeasesTotalAmount) === this.$parent.$refs.peaFinancialAssets.operatingLeasesTotalAmount) {
        return this.$parent.$refs.peaFinancialAssets.operatingLeasesTotalAmount.toFixed(2)
      }
    },
    otherExpendituresTotalAmount: function () {
      // related to prd.pub fix in peaFinancialAssets.vue
      if (parseFloat(this.$parent.$refs.peaFinancialAssets.otherExpendituresTotalAmount) === this.$parent.$refs.peaFinancialAssets.otherExpendituresTotalAmount) {
        return this.$parent.$refs.peaFinancialAssets.otherExpendituresTotalAmount.toFixed(2)
      }
    },
    expendituresTotalAmount: function () {
      var total = parseFloat(this.capitalAssetsTotalAmount) + parseFloat(this.operatingLeasesTotalAmount) + parseFloat(this.otherExpendituresTotalAmount)
      return total.toFixed(2)
    },
    netExpendituresTotalAmount: function () {
      var total = parseFloat(this.expendituresTotalAmount)
      return total.toFixed(2)
    }
  },
  data () {
    var validateMoneySize = (rule, value, callback) => {
      if (value >= 99999999999.99) {
        callback(new Error('Must be less than $99,999,999,999.99'))
      }
      callback()
    }
    var validateCostToDate = (rule, value, callback) => {
      if (value === null && this.isCompleting) {
        callback(new Error('Cost To Date is required before completion'))
      }
      callback()
    }
    return {
      financialSummaryData: {
        costToDate: 0
      },
      panelOpen: true,
      dataLoading: true,
      rules: {
        costToDate: [
          { validator: validateCostToDate, trigger: 'visible-change' },
          { validator: validateMoneySize, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    return this.getFinancialSummaryData()
  },
  methods: {
    checkFinancialSummaryValid () {
      this.$refs['financialSummaryForm'].validate((valid) => {
        if (valid) {
          this.$parent.$emit('peaFinancialSummaryValidation', true)
        } else {
          this.$parent.$emit('peaFinancialSummaryValidation', false)
          helperMethods.showNotification(this.$parent, 'Invalid Financial Summary requirements', 'Please check Financial Summary section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
        }
      })
    },
    getFinancialSummaryData () {
      this.dataLoading = true
      var call = '/getPEAFinancialSummary/' + this.peaId
      this.$axios(call).then(response => {
        this.financialSummaryData.costToDate = response.data.costToDate
        this.dataLoading = false
        this.$emit('fetchComplete')
      }).catch(response => {
        this.dataLoading = false
        helperMethods.showNotification(this.$parent, 'Error retrieving Financial Summary Info', response.body, 'error', 30000)
        this.$emit('fetchComplete')
      })
    },
    updateFinancialSummary () {
      var financialSummaryCall = '/updateFinancialSummary/' + this.peaId
      var financialSummaryDataDTO = {
        capitalAssetsTotal: this.capitalAssetsTotalAmount,
        operatingLeasesTotal: this.operatingLeasesTotalAmount,
        otherExpendituresTotal: this.otherExpendituresTotalAmount,
        totalExpenditure: this.expendituresTotalAmount,
        netExpenditure: this.netExpendituresTotalAmount,
        costToDate: this.financialSummaryData.costToDate
      }
      return new Promise((resolve, reject) => {
        this.$axios.post(financialSummaryCall, financialSummaryDataDTO).then(response => resolve(response))
          .catch(response => {
            helperMethods.showNotification(this.$parent, 'Error updating Financial Summary Information', response.body, 'error', 30000)
            reject(response)
          })
      })
    },
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    }
  }
}
</script>

<style scoped>
.pea-panel {
  padding-top: 20px;
  padding-bottom: 20px;
}

.pea-panel .el-row {
  text-align: left;
  padding: 5px 0;
}

.rowWithInput strong {
  height: 36px;
  display: table-cell;
  vertical-align: middle;
}

@media (max-width: 1199px){
  .rowWithInput .el-col {
    margin-bottom: 10px;
  }
}
</style>
